import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { HelpComponent } from './help.component';

@NgModule({
  imports: [CommonModule, BlockModalDragModule, PipesModule],
  declarations: [HelpComponent],
  exports: [HelpComponent],
})
export class HelpModule {}
